<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <linearGradient
      id="gradient"
      x1="22.4602"
      y1="0.0996092"
      x2="7.57649"
      y2="22.0373"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#FF00D6" />
      <stop offset="1" stop-color="#0072DB" />
    </linearGradient>
    <path
      d="M20 2.66663H3.99999C3.26666 2.66663 2.66666 3.26663 2.66666 3.99996V20C2.66666 20.7333 3.26666 21.3333 3.99999 21.3333H20C20.7333 21.3333 21.3333 20.7333 21.3333 20V3.99996C21.3333 3.26663 20.7333 2.66663 20 2.66663ZM12 6.33329C13.6533 6.33329 15 7.67996 15 9.33329C15 10.9866 13.6533 12.3333 12 12.3333C10.3467 12.3333 8.99999 10.9866 8.99999 9.33329C8.99999 7.67996 10.3467 6.33329 12 6.33329ZM18 18.6666H5.99999V17.6666C5.99999 15.6666 9.99999 14.6666 12 14.6666C14 14.6666 18 15.6666 18 17.6666V18.6666Z"
      fill="url(#gradient)"
      fill-opacity="0.87"
    />
  </svg>
</template>
